import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ButtonsBlock } from "../styles";

type FormActionsProps = {
  isCreateMode: boolean;
  isDraftMode: boolean;
  isFormValid: boolean;
  isDirty: boolean;
  isSavingDraft: boolean;
  isDeletingDraft: boolean;
  canSaveDraft: boolean;
  onSaveDraft: () => void;
  onDeleteDraft: () => void;
  onClose: () => void;
};

const FormActions = ({
  isCreateMode,
  isDraftMode,
  isFormValid,
  isDirty,
  isSavingDraft,
  isDeletingDraft,
  canSaveDraft,
  onSaveDraft,
  onDeleteDraft,
  onClose,
}: FormActionsProps) => {
  const { t } = useTranslation();
  const shouldShowSaveDraft = isCreateMode || isDraftMode;

  return (
    <ButtonsBlock>
      {shouldShowSaveDraft && (
        <Button
          type="button"
          variant="outlined"
          color="primary"
          fullWidth
          disabled={!canSaveDraft || isSavingDraft || isDeletingDraft}
          onClick={onSaveDraft}
        >
          {t("createAgent.formActions.saveDraft")}
        </Button>
      )}

      {isDraftMode && (
        <Button
          type="button"
          variant="outlined"
          color="error"
          fullWidth
          disabled={isSavingDraft || isDeletingDraft}
          onClick={onDeleteDraft}
        >
          {t("createAgent.formActions.deleteDraft")}
        </Button>
      )}

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={
          (isCreateMode || isDraftMode
            ? !isFormValid
            : !isDirty || !isFormValid) ||
          isSavingDraft ||
          isDeletingDraft
        }
      >
        {isDraftMode
          ? t("createAgent.formActions.publish")
          : isCreateMode
            ? t("createAgent.formActions.create")
            : t("createAgent.formActions.update")}
      </Button>

      <Button
        type="button"
        variant="outlined"
        color="secondary"
        onClick={onClose}
        fullWidth
        disabled={isSavingDraft || isDeletingDraft}
      >
        {t("createAgent.formActions.cancel")}
      </Button>
    </ButtonsBlock>
  );
};

export default FormActions;
